import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import React, { useEffect, useState } from 'react';
import breakpoints from '@constants/breakpoints';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import useWindowSize from '@hooks/useWindowSize/useWindowSize';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { IFeaturedMerchGroup, IFeaturedMerchGroups } from '../../model/featuredMerchGroups';
import styles from './FeaturedMerchGroups.module.scss';

const FeaturedMerchGroups = ({ title, merchGroups }: IFeaturedMerchGroups) => {
  const theme = useTheme();
  const { width: windowWidth } = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  const mobileBreakpoint = breakpoints['small-tablet'];
  const trackClick = (merchGroup: IFeaturedMerchGroup) => {
    analyticsTrack('merch_group_clicked', {
      title: `Shop Landing Page | Featured Merch Groups | ${merchGroup.label}`,
      merchGroup,
    });
  };

  useEffect(() => {
    const mobile = windowWidth && windowWidth < mobileBreakpoint;
    setIsMobile(!!mobile);
  }, [windowWidth]);

  return (
    <div className={styles.FeaturedMerchGroups }>
      <div className={styles.Content}>
        <div className={styles.SectionTitleWrapper}>
          <div className={classNames(styles.SectionTitle, theme.styles.Header)}>{title}</div>
          <div
            className={styles.HL}
            style={{
              borderTop: `1px solid ${theme.colors.shade1}`
            }}
          />

        </div>
        <div className={styles.ImagesWrapper}>
          {merchGroups.map((merchGroup) => {
            return (
              <div className={styles.MerchGroupCard} key={merchGroup.id}>
                <a
                  aria-label={`feature merch group - ${merchGroup.label}`}
                  role="button"
                  tabIndex={0}
                  href={merchGroup.ctaUrl}
                  onClick={() => trackClick(merchGroup)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') trackClick(merchGroup);
                  }}
                >
                  <PrismicImage
                    className={ styles.Image }
                    lazy={false}
                    image={merchGroup.image}
                    breakpoints={{
                      mobile: mobileBreakpoint - 1
                    }}
                  />
                </a>
                {merchGroup.label && (
                  <a
                    className={classNames(
                        styles.MerchGroupLabel,
                        theme.styles.Overline,
                        { [theme.styles.Core2]: isMobile }
                      )}
                    role="button"
                    tabIndex={0}
                    href={merchGroup.ctaUrl}
                    onClick={() => trackClick(merchGroup)}
                  >
                    {merchGroup.label}
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeaturedMerchGroups;
